import React from 'react'
import { Drawer, Descriptions, Divider, Space, Button, Tag, Typography, Avatar } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import type { Brand } from '../types/brand.types'
import { DocumentAvatar } from '../../../shared/components/DocumentAvatar'

const { Text } = Typography

interface BrandDetailsDrawerProps {
    open: boolean
    onClose: () => void
    brand: Brand | null
    onEdit: (brand: Brand) => void
    onDelete: (brand: Brand) => void
}

export const BrandDetailsDrawer: React.FC<BrandDetailsDrawerProps> = ({
    open,
    onClose,
    brand,
    onEdit,
    onDelete
}) => {
    if (!brand) return null

    return (
        <Drawer
            title="Brand Details"
            placement="right"
            width={600}
            onClose={onClose}
            open={open}
        >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                    {brand.logo ? (
                        <DocumentAvatar documentId={brand.logo} size={80} />
                    ) : brand.logoUrl ? (
                        <Avatar src={brand.logoUrl} size={80} />
                    ) : (
                        <Avatar size={80} style={{ backgroundColor: '#7c3aed', fontSize: 32 }}>
                            {brand.name.charAt(0)}
                        </Avatar>
                    )}
                </div>

                <Descriptions title="Brand Information" column={1} bordered>
                    <Descriptions.Item label="Brand Name">
                        <Text strong>{brand.name}</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="Description">
                        {brand.description}
                    </Descriptions.Item>
                    <Descriptions.Item label="Products">
                        <Tag color="blue">{brand.productCount} products</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                        <Tag color={brand.status === 'active' ? 'green' : 'gray'}>
                            {brand.status.toUpperCase()}
                        </Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Created">{brand.createdAt}</Descriptions.Item>
                </Descriptions>

                <Divider />

                <Space>
                    <Button type="primary" icon={<EditOutlined />} onClick={() => onEdit(brand)}>
                        Edit Brand
                    </Button>
                    <Button danger icon={<DeleteOutlined />} onClick={() => onDelete(brand)}>
                        Delete Brand
                    </Button>
                </Space>
            </Space>
        </Drawer>
    )
}
